import React from 'react';
import { useTheme } from '@gr/ui-neo';
import { useLivechatBubbleButtonStyles } from './useLivechatBubbleButtonStyles';
export const LivechatBubbleButton = React.forwardRef(({ visible, onClick, onStartDragging, position }, ref) => {
    const mouseDownPosition = React.useRef(null);
    const theme = useTheme();
    const classes = useLivechatBubbleButtonStyles({
        theme,
        visible,
        position,
    });
    // Cancel moving state when mouseup happened outside
    React.useEffect(() => {
        const handler = () => {
            mouseDownPosition.current = null;
        };
        document.addEventListener('mouseup', handler);
        return () => {
            document.removeEventListener('mouseup', handler);
        };
    }, []);
    const onMouseDown = React.useCallback((event) => {
        mouseDownPosition.current = {
            x: event.pageX,
            y: event.pageY,
        };
    }, []);
    const onMouseUp = React.useCallback(() => {
        mouseDownPosition.current = null;
        onClick();
    }, [onClick]);
    const onMouseMove = React.useCallback((event) => {
        if (!mouseDownPosition.current) {
            return;
        }
        const delta = 4;
        const diffX = Math.abs(event.pageX - mouseDownPosition.current.x);
        const diffY = Math.abs(event.pageY - mouseDownPosition.current.y);
        // Ignore tiny moves that could happen during mouseup
        if (diffX > delta || diffY > delta) {
            onStartDragging(event);
        }
    }, [onStartDragging]);
    const onKeyDown = React.useCallback((event) => {
        if (!['Enter', ' '].includes(event.key)) {
            return;
        }
        onClick();
    }, [onClick]);
    return (React.createElement("button", { onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseMove: onMouseMove, className: classes['livechat-button'], "aria-hidden": !visible, type: "button", onKeyDown: onKeyDown, ref: ref, "data-ats-live-chat-button": "activator" },
        React.createElement("svg", { "aria-hidden": true, xmlns: "http://www.w3.org/2000/svg", width: "18", height: "16", fill: "none", viewBox: "0 0 16 16" },
            React.createElement("path", { fill: "white", d: "M4 15v-3h4l-4 3z" }),
            React.createElement("rect", { width: "14", height: "10", x: "1", y: "2", fill: "white", rx: "2" }))));
});
